import posthog from "posthog-js";

// Rails renders these meta tags from credentials and current_user in the layout.
const posthogApiKey = document.querySelector("meta[name='posthog-api-key']")?.content;
const posthogHost = document.querySelector("meta[name='posthog-host']")?.content;
const posthogUiHost = document.querySelector("meta[name='posthog-ui-host']")?.content;
const currentUserId = document.querySelector("meta[name='current-user-posthog-id']")?.content;
const currentUserRole = document.querySelector("meta[name='current-user-role']")?.content;

// Skip initialization when a local/test-like environment does not expose a project key.
if (posthogApiKey) {
  // This is the browser SDK initialization recommended by PostHog.
  // The project API key is intentionally public; it identifies the PostHog project,
  // not a private server-side credential.
  posthog.init(posthogApiKey, {
    api_host: posthogHost || "https://us.i.posthog.com",
    ui_host: posthogUiHost || "https://us.posthog.com",
    defaults: "2026-01-30",
    // Turbo handles page navigation without full reloads, so pageviews are captured
    // manually on turbo:load below to avoid missed or duplicate $pageview events.
    capture_pageview: false,
    // PostHog uses $pageleave for bounce rate and session duration accuracy.
    // Keep this enabled even though $pageview is captured manually.
    capture_pageleave: true,
  });

  // Match the backend distinct_id so Rails events and browser events land on the same user.
  if (currentUserId) {
    posthog.identify(currentUserId, {
      role: currentUserRole,
    });
  }

  // Turbo changes pages without a full reload, so capture pageviews on turbo:load.
  document.addEventListener("turbo:load", () => {
    posthog.capture("$pageview");
  });
}

export default posthog;
